import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

var setValue = function setValue(_ref, state, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
      field = _ref3[0],
      value = _ref3[1];

  var changeValue = _ref2.changeValue;
  changeValue(state, field, function () {
    if (typeof value === 'function') return value(state);
    return value;
  });
};

function FormProvider(props) {
  return React.createElement(Form, Object.assign({
    mutators: _objectSpread({}, arrayMutators, {
      setValue: setValue
    })
  }, props));
}

export default FormProvider;